import { render, staticRenderFns } from "./searchBox.vue?vue&type=template&id=442df824&scoped=true&"
import script from "./searchBox.vue?vue&type=script&lang=js&"
export * from "./searchBox.vue?vue&type=script&lang=js&"
import style0 from "./searchBox.vue?vue&type=style&index=0&id=442df824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442df824",
  null
  
)

export default component.exports